export const translation = {
  // Navbar
  nav_spreadsheet: 'Spreadsheet',
  nav_categories: 'Kategorien',
  nav_guides: 'Anleitungen',
  nav_shipping: 'Versand',
  nav_qc: 'QC',
  nav_reviews: 'Bewertungen',
  nav_language: 'Sprache',
  nav_cta: 'Hauptseite Besuchen',
  nav_home: 'Startseite',
  nav_shopping_guide: 'Einkaufsführer',

  // Hero
  hero_eyebrow: 'DIE ALLCHINABUY SPREADSHEET RESSOURCEN-ZENTRALE',
  hero_title: 'AllChinaBuy Spreadsheet — Produkte, Verkäufer und Kaufanleitungen Finden',
  hero_desc: 'Suchen Sie nach einem AllChinaBuy Spreadsheet? Entdecken Sie kuratierte Produktressourcen, Verkäuferinformationen, QC-Anleitungen, Versandtipps und praktische Kaufanleitungen — alles in einem übersichtlichen Ressourcen-Hub.',
  hero_cta_primary: 'AllChinaBuy Spreadsheet Erkunden',
  hero_cta_secondary: 'Kaufanleitungen Durchsuchen',
  hero_trust: 'Unabhängige Ressource · Regelmäßig aktualisiert · Mehrsprachig',
  hero_search_placeholder: 'AllChinaBuy Spreadsheet, Produkte, Verkäufer oder Anleitungen suchen...',

  // Trust Bar
  trust_spreadsheet: 'Spreadsheet-Ressourcen',
  trust_spreadsheet_desc: 'Organisierte Produkt- und Verkäuferinformationen.',
  trust_guides: 'Kaufanleitungen',
  trust_guides_desc: 'Praktische Anleitungen für neue und erfahrene Nutzer.',
  trust_qc: 'QC & Sicherheit',
  trust_qc_desc: 'Qualitätskontrollen und häufige Risiken verstehen.',
  trust_shipping: 'Versandressourcen',
  trust_shipping_desc: 'Erfahren Sie mehr über Versandmethoden, Kosten und Aspekte.',

  // What Is Section
  what_is_title: 'Was ist ein AllChinaBuy Spreadsheet?',
  what_is_desc: 'Ein AllChinaBuy Spreadsheet ist eine praktische Möglichkeit, Produkt-, Verkäufer- und Einkaufsinformationen an einem Ort zu organisieren. Unser Ressourcen-Hub hilft Ihnen, nützliche Ressourcen zu entdecken, Kategorien zu verstehen, Optionen zu vergleichen und den Kaufprozess zu lernen.',
  what_is_cta: 'Spreadsheet-Hub Erkunden →',

  // Categories Section
  categories_title: 'Beliebte Kategorien Durchsuchen',
  categories_cta: 'Alle Kategorien Erkunden →',

  // Popular Searches
  popular_title: 'Beliebte AllChinaBuy-Suchen',
  popular_spreadsheet: 'AllChinaBuy Spreadsheet',
  popular_review: 'AllChinaBuy Bewertung',
  popular_shipping: 'AllChinaBuy Versandkosten',
  popular_coupon: 'AllChinaBuy Gutschein',
  popular_discount: 'AllChinaBuy Rabattcode',
  popular_warehouse: 'AllChinaBuy Lager',
  popular_legit: 'AllChinaBuy Seriös',
  popular_qc: 'AllChinaBuy QC',

  // Buying Guides
  guides_title: 'AllChinaBuy Kaufanleitungen',
  guides_desc: 'Lernen Sie, wie Sie Produkte finden, Verkäufer bewerten, QC-Informationen verstehen, Versandkosten schätzen und häufige Fehler mit praktischen AllChinaBuy-Anleitungen vermeiden.',
  guides_cta: 'Alle Anleitungen Ansehen →',
  pillar_title: 'AllChinaBuy Kernartikel',
  pillar_desc: 'Ausführliche Original-Anleitungen zu Spreadsheets, Bewertungen, Versand, Lager, QC, Verkäufern und Vergleichen.',
  guide_1_title: 'Vollständige Spreadsheet-Anleitung',
  guide_1_desc: 'Beherrschen Sie das AllChinaBuy Spreadsheet mit unserer umfassenden Anleitung.',
  guide_2_title: 'Versandkosten-Rechner',
  guide_2_desc: 'Schätzen Sie Versandkosten vor dem Kauf mit unserer detaillierten Aufschlüsselung.',
  guide_3_title: 'QC-Foto-Checkliste',
  guide_3_desc: 'Lernen Sie, was Sie bei Qualitätskontrollfotos jedes Mal beachten sollten.',
  guide_4_title: 'Verkäufer-Verifizierungsanleitung',
  guide_4_desc: 'So identifizieren Sie zuverlässige Verkäufer und vermeiden häufige Betrügereien.',
  guide_5_title: 'Lagerprozess Erklärt',
  guide_5_desc: 'Verstehen Sie, wie das AllChinaBuy-Lager Ihre Artikel verwaltet.',
  guide_6_title: 'Anfänger-Kaufstrategie',
  guide_6_desc: 'Wichtige Tipps für Erstkäufer bei AllChinaBuy.',

  // Comparison
  comparison_title: 'AllChinaBuy im Vergleich mit anderen Einkaufsplattformen',
  comparison_cta: 'Alle Vergleiche Ansehen →',
  vs_superbuy: 'AllChinaBuy vs Superbuy',
  vs_cssbuy: 'AllChinaBuy vs CSSBuy',
  vs_sugargoo: 'AllChinaBuy vs Sugargoo',
  vs_kakobuy: 'AllChinaBuy vs Kakobuy',

  // Safety Section
  safety_title: 'AllChinaBuy Sicherheitszentrum',
  safety_desc: 'Bevor Sie kaufen, lernen Sie, wie Sie Verkäufer bewerten, Ihr Konto schützen, verdächtige Links erkennen, Zahlungsrisiken verstehen und bessere Kaufentscheidungen treffen.',
  safety_cta: 'Sicherheitszentrum Besuchen →',

  // Review Section
  review_title: 'Ist AllChinaBuy Seriös?',
  review_desc: 'Fragen Sie sich, ob AllChinaBuy seriös ist, wie das Lager funktioniert oder was Sie vom Versand erwarten können? Unsere unabhängigen Anleitungen erklären die wichtigsten Aspekte.',
  review_cta: 'Die AllChinaBuy Bewertung Lesen →',

  // FAQ
  faq_title: 'AllChinaBuy Spreadsheet FAQ',
  faq_q1: 'Was ist ein AllChinaBuy Spreadsheet?',
  faq_a1: 'Ein AllChinaBuy Spreadsheet ist eine kuratierte Sammlung von Produktlinks, Verkäuferinformationen und Kaufressourcen zur einfachen Referenz.',
  faq_q2: 'Wie verwende ich ein AllChinaBuy Spreadsheet?',
  faq_a2: 'Durchsuchen Sie einfach die Kategorien, klicken Sie auf Produktlinks, um Details anzusehen, und folgen Sie den Kaufanleitungen, um Ihren Kauf sicher abzuschließen.',
  faq_q3: 'Ist AllChinaBuy seriös?',
  faq_a3: 'AllChinaBuy ist eine bekannte Einkaufsagentur-Plattform. Wie bei jedem Online-Dienst ist es wichtig, den Prozess zu verstehen und Sicherheitsrichtlinien zu befolgen.',
  faq_q4: 'Ist AllChinaBuy sicher?',
  faq_a4: 'Sicherheit hängt von Best Practices ab: Verkäufer verifizieren, QC-Fotos nutzen, Versandkosten verstehen und unsere Sicherheitsanleitungen lesen.',
  faq_q5: 'Wie viel kostet der AllChinaBuy-Versand?',
  faq_a5: 'Versandkosten variieren je nach Ziel, Gewicht und Versandmethode. Nutzen Sie unsere Anleitung, um Kosten vor der Bestellung zu schätzen.',
  faq_q6: 'Hat AllChinaBuy ein Lager?',
  faq_a6: 'Ja, AllChinaBuy betreibt Lager, in denen Artikel gelagert, inspiziert und konsolidiert werden, bevor sie international versandt werden.',
  faq_q7: 'Bietet AllChinaBuy Coupons oder Rabattcodes an?',
  faq_a7: 'Rabattcodes können periodisch verfügbar sein. Prüfen Sie unsere Gutscheinanleitung für aktuelle Angebote.',
  faq_q8: 'Wie überprüfe ich die Produktqualität?',
  faq_a8: 'Fordern Sie immer QC-Fotos (Qualitätskontrolle) vor dem Versand an. Unsere QC-Anleitung erklärt genau, worauf Sie achten sollten.',

  // Final CTA
  final_cta_title: 'Bereit, das AllChinaBuy Spreadsheet zu Erkunden?',
  final_cta_desc: 'Starten Sie mit dem Spreadsheet-Hub, erkunden Sie beliebte Produkte, vergleichen Sie Optionen und lernen Sie den Kaufprozess mit unseren neuesten Anleitungen.',
  final_cta_primary: 'AllChinaBuy Spreadsheet Erkunden',
  final_cta_secondary: 'Hauptseite Besuchen',
  final_cta_buy_now: 'Jetzt Kaufen',

  // Footer
  footer_disclaimer: 'Diese Website ist eine unabhängige Informationsressource. Es ist nicht die offizielle AllChinaBuy-Website, es sei denn, es wird ausdrücklich anders angegeben. Informationen können sich ändern, bitte vor dem Kauf verifizieren.',
  footer_copyright: '© 2026 allchinabuyspread.cc — Alle Rechte vorbehalten.',
  footer_links: 'Schnelllinks',
  footer_resources: 'Ressourcen',
  footer_legal: 'Rechtliches',
  footer_privacy: 'Datenschutzrichtlinie',
  footer_terms: 'Nutzungsbedingungen',
  footer_disclaimer_link: 'Haftungsausschluss',
  footer_contact: 'Kontakt',
  footer_about: 'Über Uns',

  // Common
  allchinabuy_spreadsheet: 'AllChinaBuy Spreadsheet',
  read_more: 'Mehr Lesen',
  learn_more: 'Mehr Erfahren',
  search: 'Suchen',
  category: 'Kategorie',
  product: 'Produkt',
  seller: 'Verkäufer',
  price: 'Preis',
  last_updated: 'Zuletzt Aktualisiert',

  // Dropdown categories
  cat_shoes: 'Schuhe',
  cat_hoodies: 'Hoodies / Pullover',
  cat_tshirts: 'T-Shirts',
  cat_jackets: 'Jacken',
  cat_pants: 'Hosen / Shorts',
  cat_headwear: 'Kopfbedeckungen',
  cat_sets: 'Sets',
  cat_underwear: 'Unterwäsche',
  cat_jersey: 'Trikots',
  cat_accessories: 'Accessoires',
  cat_bags: 'Taschen',
  cat_belts: 'Gürtel',
  cat_perfumes: 'Parfums',
  cat_other: 'Sonstiges',
};